import { useStore } from 'vuex';
import { openAuthPopinHandler } from '@core/utils/auth-popin-handler';
import { useAuthPopinState } from '@core/composables/use-auth-popin-state';
import type { AuthPopinData } from '@monolith/legacy/types/auth-popin';

export function useAuthPopin() {
  const store = useStore();
  const { openAuthPopinModal } = useAuthPopinState();

  const fetchBrandData = async (brandId: string) => {
    await store.dispatch('shop/fetchBrand', { brand_id: brandId });
  };

  const openAuthPopin = (
    view: Parameters<typeof openAuthPopinHandler>[1],
    data: AuthPopinData | null = {},
    successCallback?: () => void,
  ) => openAuthPopinHandler(
    {
      dispatch: (action, payload?) => store.dispatch(action, payload),
      getBrandById: (id) => store.getters['shop/brandById'](id),
      fetchBrandData,
      getWrapper: () => ({ openModal: openAuthPopinModal }),
    },
    view,
    data,
    successCallback,
  );

  return {
    openAuthPopin,
    fetchBrandData,
  };
}
